import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SelectWidget } from '@plone/volto/components';
import QuerystringWidget from '@plone/volto/components/manage/Widgets/QuerystringWidget';
import { defineMessages, useIntl } from 'react-intl';
import { CheckboxWidget } from '@plone/volto/components';

const messages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  itemBatchSize: {
    id: 'Item batch size',
    defaultMessage: 'Item batch size',
  },
  excludeExperiences: {
    id: 'Exclude experiences',
    defaultMessage: 'Escludi esperienze',
  }
});

const Sidebar = (props) => {
  const intl = useIntl();
  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="SearchEventsBlock"
            defaultMessage="Ricerca eventi"
          />
        </h2>
      </header>
      <Segment className="form sidebar-listing-data">
        <SelectWidget
          id="whichEvents"
          title="Quali eventi"
          required={false}
          description="Se impostato, il blocco preimposterà le date per mostrare gli eventi che corrispondono al valore selezionato"
          value={props.data.whichEvents}
          onChange={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          choices={[
            ['today', 'Del giorno'],
            ['weekend', 'Del weekend'],
            ['month', 'Del mese'],
          ]}
        />

      <CheckboxWidget
            id="excludeExperiences"
            title={intl.formatMessage(messages.excludeExperiences)}
            value={props.data.excludeExperiences ? props.data.excludeExperiences : false}
            onChange={(id, value) => {
              props.onChangeBlock(props.block, {
                ...props.data,
                [id]: value,
              });
            }}
          />

        <QuerystringWidget
          id="source"
          title={intl.formatMessage(messages.Source)}
          required={false}
          value={props.data.querystring || []}
          onChange={(name, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              querystring: value,
            });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default injectIntl(Sidebar);
